// Southern Star RX (Pharmacy) nationwide coverage — state names match us-states.geojson "name" property

export const SERVICED_STATES = [
  "Alabama", "Arizona", "Colorado", "Connecticut", "Delaware", "District of Columbia",
  "Florida", "Georgia", "Idaho", "Illinois", "Indiana", "Iowa", "Maine", "Maryland",
  "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
  "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
  "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
  "Rhode Island", "Tennessee", "Texas", "Utah", "Vermont", "Virginia",
  "West Virginia", "Wisconsin", "Wyoming",
];

// Serviced, but compounds are NOT available
export const NO_COMPOUND_STATES = ["Iowa", "Mississippi", "Ohio", "Oklahoma"];

// Full-service states (serviced AND compounds available) — no overlap with NO_COMPOUND_STATES
export const FULL_SERVICE_STATES = SERVICED_STATES.filter((s) => !NO_COMPOUND_STATES.includes(s));

export const PHARMACY_COLORS = {
  serviced: "#4F46E5",     // indigo — full service
  noCompound: "#F59E0B",   // amber — serviced, no compounds
  notServiced: "#334155",  // slate — not serviced
};

export const SERVICED_COUNT = SERVICED_STATES.length; // 41 jurisdictions (40 states + DC)
